import { Component, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { IonModal, ModalController, ToastController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { NgControl } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { FormCoachComponent } from '../form-coach/form-coach.component';
import { map } from 'rxjs/operators';
import { YesNoModalComponent } from 'src/app/components/shared/modals/yes-no-modal/yes-no-modal.component';
import { User } from 'src/app/micro-services/user/models/user';


@Component({
  selector: 'app-list-coach',
  templateUrl: './list-coach.component.html',
  styleUrls: ['./list-coach.component.scss'],
})
export class ListCoachComponent implements OnInit {

  @ViewChild(IonModal) modal: IonModal;
  message: string;
  coaches$ : Observable<User[]>;
  save$ : Observable<User[]>;
  title: string;
  isModalOpen: boolean;
  isEdit: boolean;
  coachEdit: string;


  constructor(
    public apiProvider: ApiProviderService,
    private modalCtrl : ModalController,
    private toastController : ToastController
  ) { }
  
 

  ngOnInit() {
    this.coaches$ = this.save$ = this.apiProvider.getCoaches();
  }

  async addCoach(){

    const modalEdition = await this.modalCtrl.create({
      component: FormCoachComponent
    });
    modalEdition.present();

    const { data, role } = await modalEdition.onWillDismiss();
    
    if (role === 'create') {
      if(data){
        this.coaches$ = this.coaches$.pipe(
          map(
            address => {
              return address;
            }
          )
        )
      }
    }
  }

  
  async editCoach(coach : User){

    const modalEdition = await this.modalCtrl.create({
      component: FormCoachComponent,
      componentProps: { coach : coach }
    });
    modalEdition.present();

    const { data, role } = await modalEdition.onWillDismiss();
    
    if (role === 'edit') {
      if(data){
        this.coaches$ = this.coaches$.pipe(
          map(coaches => {
            var test = coaches.find(address => address.id == data.id)
            test = data;
            return coaches;
          })
        )
      }
    }
  }

  async deleteCoach(user : User){

    const modalEdition = await this.modalCtrl.create({
      component: YesNoModalComponent,
      componentProps : {
        title : "Suppression",
        text : "Confirmation de la suppression ?"
      }
    });
    modalEdition.present();

    const { role } = await modalEdition.onWillDismiss();

    if (role === 'confirm') {
      //delete
      this.apiProvider.deleteCoach(user).subscribe({
        next : (deleteId) => {
          
          if(deleteId){
            this.coaches$ = this.coaches$.pipe(
              map(coaches => {
                var index = coaches.findIndex(coach => coach.id == deleteId)
                if (index >= 0 ) {
                  coaches.splice(index,1);
                }
                return coaches;
              })
            )
          }
        },
        error : () => {
          this.toastController.create(
            {
              message: 'Erreur lors de la suppression',
              duration: 1500,
            }
          )
        }
      })
    }
  }
 }
 
